export default __webpack_public_path__ + "static/media/homepage-hero.57ee7af5.jpg";